import React, { useEffect, useState } from 'react';
import { Panel } from 'react-instantsearch-dom';
import Select from 'react-select';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlay } from '@fortawesome/free-solid-svg-icons';
import { isEqual } from 'lodash';
import {
  AdminDashboardFiltersInterface,
  AttributesInterface,
  FacetObject,
} from '../../admin-dashboard-tables/interfaces';
import FilterSVG from '../../../svgComponents/FilterSVG';
import SelectDropdown from './AdminSelectDropdown';
import DateRange from './DateRange';
import AdminValueContainer from './react-select-custom-child-components/AdminValueContainer';
import CheckBoxOption from './react-select-custom-child-components/checkbox-option';
import ToggleSwitch from './ToggleSwitch';
import AdminSimpleSelectDropdown from './AdminSimpleSelectDropdown';

const AdminDashboardFilters: React.FC<AdminDashboardFiltersInterface> = ({
  facetFilters,
  setFacetFilters,
  numericFilters,
  setNumericFilters,
  attributes,
  indexName,
  searchClient,
}) => {
  // @ts-ignore
  const [staticFilters, setStaticFilters] = useState(
    attributes.filter((attr: AttributesInterface) => !attr.isToggleable),
  );
  // @ts-ignore
  const [toggleableFilters, setToggleableFilters] = useState(
    attributes.filter((attr: AttributesInterface) => attr.isToggleable),
  );
  const [toggleableVisible, setToggleableVisible] = useState<Array<string>>([]);

  useEffect(() => {
    const newStatic = attributes.filter((attr: AttributesInterface) => !attr.isToggleable);
    const newToggleable = attributes.filter((attr: AttributesInterface) => attr.isToggleable);

    if (!isEqual(staticFilters, newStatic)) {
      setStaticFilters(newStatic);
    }

    if (!isEqual(toggleableFilters, newToggleable)) {
      setToggleableFilters(newToggleable);
    }
  }, [attributes]);

  return (
    <>
      {
        staticFilters.map((attributeObject: AttributesInterface) => {
          if (attributeObject.type === 'facet_switch') {
            return (
              <Panel
                key={attributeObject.attribute}
                className="mr-3 mb-3 d-flex align-items-center"
              >
                <ToggleSwitch
                  label={attributeObject.label}
                  attribute={attributeObject.attribute}
                  id={attributeObject.attribute}
                  facetFilters={facetFilters}
                  setFacetFilters={setFacetFilters}
                  toggleCallback={attributeObject.toggleCallback}
                />
              </Panel>
            );
          }
          if (attributeObject.type === 'facet' && attributeObject.simpleOptions && attributeObject.simpleOptions.length > 0) {
            return (
              <Panel
                key={attributeObject.attribute}
                className="mr-3 mb-3"
              >
                <AdminSimpleSelectDropdown
                  facetFilters={facetFilters}
                  setFacetFilters={setFacetFilters}
                  attributeObject={attributeObject}
                  attribute={attributeObject.attribute}
                  max={attributeObject.max}
                  andSearch={attributeObject.andSearch}
                />
              </Panel>
            );
          }
          if (attributeObject.type === 'facet') {
            return (
              <Panel
                key={attributeObject.attribute}
                className="mr-3 mb-3"
              >
                <SelectDropdown
                  searchClient={searchClient}
                  facetFilters={facetFilters}
                  setFacetFilters={setFacetFilters}
                  attributeObject={attributeObject}
                  attribute={attributeObject.attribute}
                  addCount={attributeObject.addCount}
                  limit={100}
                  max={attributeObject.max}
                  andSearch={attributeObject.andSearch}
                  indexName={indexName}
                />
              </Panel>
            );
          }
          if (attributeObject.type === 'dateRange') {
            return (
              <DateRange
                key={attributeObject.attribute}
                attribute={attributeObject.attribute}
                attributeObject={attributeObject}
                numericFilters={numericFilters}
                setNumericFilters={setNumericFilters}
              />
            );
          }
          return (<></>);
        })
      }
      {
        toggleableFilters.map((attributeObject: AttributesInterface) => {
          if (attributeObject.type === 'facet' && attributeObject.simpleOptions && attributeObject.simpleOptions.length > 0) {
            return (
              <div
                key={attributeObject.attribute}
                style={{
                  display: toggleableVisible.includes(attributeObject.attribute)
                    ? 'flex'
                    : 'none',
                }}
              >
                <Panel className="mr-3 mb-3">
                  <AdminSimpleSelectDropdown
                    facetFilters={facetFilters}
                    setFacetFilters={setFacetFilters}
                    attributeObject={attributeObject}
                    attribute={attributeObject.attribute}
                    max={attributeObject.max}
                    andSearch={attributeObject.andSearch}
                  />
                </Panel>
              </div>
            );
          }
          if (attributeObject.type === 'facet') {
            return (
              <div
                key={attributeObject.attribute}
                style={{
                  display: toggleableVisible.includes(attributeObject.attribute)
                    ? 'flex'
                    : 'none',
                }}
              >
                <Panel className="mr-3 mb-3">
                  <SelectDropdown
                    searchClient={searchClient}
                    facetFilters={facetFilters}
                    setFacetFilters={setFacetFilters}
                    attributeObject={attributeObject}
                    attribute={attributeObject.attribute}
                    limit={100}
                    indexName={indexName}
                  />
                </Panel>
              </div>
            );
          }
          if (attributeObject.type === 'dateRange') {
            return (
              <div
                key={attributeObject.attribute}
                style={{
                  display: toggleableVisible.includes(attributeObject.attribute)
                    ? 'flex'
                    : 'none',
                }}
              >
                <DateRange
                  attribute={attributeObject.attribute}
                  attributeObject={attributeObject}
                  numericFilters={numericFilters}
                  setNumericFilters={setNumericFilters}
                />
              </div>
            );
          }
          return (<></>);
        })
      }
      {
        toggleableFilters.length > 0 && (
          <Panel className="mr-3 mb-3">
            <Select
              isClearable
              isMulti
              isSearchable={false}
              className="algolia-select btn btn-outline-light border-border-grey button-shadow text-dark-btn-txt align-items-center w-100"
              classNamePrefix="algolia-select"
              placeholder=""
              newValueComponent={(
                <span className="d-flex align-items-center mr-1">
                  <span
                    className="d-flex align-items-center mr-2"
                    style={{
                      width: '17px',
                      height: '17px',
                    }}
                  >
                    <FilterSVG />
                  </span>
                  <span>More Filters</span>
                </span>
              )}
              components={{
                ValueContainer: AdminValueContainer,
                Option: CheckBoxOption,
                DropdownIndicator: () => (<FontAwesomeIcon icon={faPlay} size="xs" transform={{ rotate: 90 }} />),
                IndicatorSeparator: () => null,
              }}
              options={
                toggleableFilters.map((attr: AttributesInterface) => {
                  return { value: attr.attribute, label: attr.label };
                })
              }
              onChange={(e) => {
                if (e) {
                  // Multiselect will return an array
                  if (Array.isArray(e)) {
                    setToggleableVisible(e.map((attribute: FacetObject) => attribute.value));
                  }
                } else {
                  setToggleableVisible([]);
                }
              }}
            />
          </Panel>
        )
      }
    </>
  );
};

export default AdminDashboardFilters;
